import React, { useState, useEffect, useContext } from "react";
import { TranslatorContext } from "../../../context/Translator";
import Modal from 'react-bootstrap/Modal';
import { AnchorComponent, ButtonComponent } from "../../elements";

export default function CheckerProductsTableComponent({ thead, tbody, activeTab }) {
    const { t } = useContext(TranslatorContext);

    const [alertModal, setAlertModal] = useState(false);
    const [data, setData] = useState([]);

    useEffect(() => {
        setData(tbody || []);
    }, [tbody]);

    return (
        <div className="mc-table-responsive">
            <table className="mc-table product">
                <thead className="mc-table-head primary">
                    <tr>
                        {thead?.map((item, index) => (
                            <th key={index}>{t(item)}</th>
                        ))}
                    </tr>
                </thead>
                <tbody className="mc-table-body even">
                    {data && data.length > 0 ? (
                        data.map((item, index) => {
                            const pImage = item?.first_img ? `${process.env.REACT_APP_IMG_URL}${item.first_img}` : "";
                            const pTitle = item?.title || "N/A";
                            const pDescribe = item?.selling_style || "N/A";
                            const pCode = item?.product_code || "N/A";
                            const style = item?.selling_style || "N/A";
                            const pQty = item?.product_qty ?? 0;

                            const pCategory = typeof item?.category === "object"
                                ? item?.category?.name
                                : (item?.category || "N/A");

                            const pBrand = typeof item?.brand === "object"
                                ? item?.brand?.name
                                : (item?.brand || "N/A");

                            const pricePrev = typeof item?.price === "object" ? item?.price?.previous : null;
                            const pricePresent = typeof item?.price === "object"
                                ? item?.price?.present
                                : (item?.price || item?.buying_price || item?.sell_price_dollar || 0);

                            const iconView = "visibility";
                            const iconEdit = "edit";

                            return (
                                <tr key={item?.id || index}>
                                    <td>
                                        <div className="mc-table-check">
                                            {pCode}
                                        </div>
                                    </td>
                                    <td>
                                        <div className="mc-table-product md">
                                            {pImage && <img src={pImage} alt={pTitle} />}
                                            <div className="mc-table-group">
                                                <h6>{pTitle}</h6>
                                                <p>{pDescribe}</p>
                                            </div>
                                        </div>
                                    </td>

                                    <td>{pCategory}</td>
                                    <td>{pBrand}</td>
                                    <td>{style}</td>
                                    <td>
                                        <div className="mc-table-price">
                                            {pricePrev && <del>{pricePrev}</del>}
                                            <p>${pricePresent}</p>
                                        </div>
                                    </td>
                                    <td>{pQty}</td>

                                    <td>
                                        <div className="mc-table-action">
                                            {/* Eye (View) Icon for ALL tabs */}
                                            <AnchorComponent
                                                to={`/checker-products-view/${item?.id || ''}`}
                                                state={{ item }}
                                                title="View"
                                                className="material-icons view"
                                            >
                                                {iconView}
                                            </AnchorComponent>

                                            {/* Edit Icon ONLY for 'new' products tab */}
                                            {activeTab === "new" && (
                                                <AnchorComponent
                                                    to={'/checker-products-edit'}
                                                    state={{ item }}
                                                    title="Edit"
                                                    className="material-icons edit"
                                                >
                                                    {iconEdit}
                                                </AnchorComponent>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td colSpan={thead?.length || 8} className="text-center py-4">
                                {t("no_products_found")}
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>

            <Modal show={alertModal} onHide={() => setAlertModal(false)}>
                <div className="mc-alert-modal">
                    <i className="material-icons">new_releases</i>
                    <h3>{t("are_you_sure")}</h3>
                    <p>{t("want_to_delete_this_product")}</p>
                    <Modal.Footer>
                        <ButtonComponent type="button" className="btn btn-secondary" onClick={() => setAlertModal(false)}>{t('close')}</ButtonComponent>
                        <ButtonComponent type="button" className="btn btn-danger" onClick={() => setAlertModal(false)}>{t('delete')}</ButtonComponent>
                    </Modal.Footer>
                </div>
            </Modal>
        </div>
    );
}